import { render, staticRenderFns } from "./chat-modal.vue?vue&type=template&id=7052d56f"
import script from "./chat-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./chat-modal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports